import React, { FC } from 'react';
import { ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { SecondaryLink, StyledAvatar, StyledSkeleton } from './styles';

const BottomMenuItemSkeleton: FC = () => (
  <ListItem>
    <ListItemIcon>
      <StyledSkeleton variant="circular">
        <StyledAvatar />
      </StyledSkeleton>
    </ListItemIcon>

    <ListItemText
      primary={<StyledSkeleton />}
      secondary={
        <SecondaryLink>
          <StyledSkeleton />
        </SecondaryLink>
      }
    />
  </ListItem>
);

export default BottomMenuItemSkeleton;
